import { cn } from "../lib/utils.js";

export type StatusVariant =
	| "active"
	| "bound"
	| "quoted"
	| "review"
	| "pending"
	| "declined"
	| "expired"
	| "revoked"
	| "lapsed";

const STATUS_CONFIG: Record<
	StatusVariant,
	{ label: string; bg: string; color: string }
> = {
	active: {
		label: "Active",
		bg: "rgba(127, 184, 122, 0.18)",
		color: "#2E7A2A",
	},
	bound: { label: "Bound", bg: "rgba(127, 184, 122, 0.18)", color: "#2E7A2A" },
	quoted: {
		label: "Quoted",
		bg: "rgba(107, 212, 223, 0.18)",
		color: "#0E6A74",
	},
	review: {
		label: "In Review",
		bg: "rgba(232, 169, 59,  0.18)",
		color: "#7A5A10",
	},
	pending: {
		label: "Pending",
		bg: "rgba(232, 169, 59,  0.18)",
		color: "#7A5A10",
	},
	declined: {
		label: "Declined",
		bg: "rgba(210, 106, 106, 0.18)",
		color: "#9C3636",
	},
	expired: {
		label: "Expired",
		bg: "rgba(210, 106, 106, 0.18)",
		color: "#9C3636",
	},
	revoked: {
		label: "Revoked",
		bg: "rgba(210, 106, 106, 0.18)",
		color: "#9C3636",
	},
	lapsed: {
		label: "Lapsed",
		bg: "rgba(139, 144, 164, 0.14)",
		color: "#5B6280",
	},
};

interface StatusPillProps {
	status: StatusVariant;
	label?: string;
	className?: string;
}

export function StatusPill({ status, label, className }: StatusPillProps) {
	const cfg = STATUS_CONFIG[status];
	const text = label ?? cfg.label;

	return (
		<span
			className={cn(
				"inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-semibold",
				className,
			)}
			style={{ background: cfg.bg, color: cfg.color }}
		>
			<span
				className="inline-block h-[5px] w-[5px] rounded-full flex-shrink-0"
				style={{ background: cfg.color }}
			/>
			{text}
		</span>
	);
}
